"use strict";
// Where things are in an STM002 Repaint Take Off. The header (rows 1–34), the
// paint slots and the Summary are fixed; the area blocks are not — estimators
// insert rows inside an area, and older revs (40.9x) have shorter blocks — so
// every block, and every row inside one, is found by its label (read
// 2026-10-15 across ten real take-offs; docs/TAKEOFF-LAYOUT.md). Shared by the
// importer (m2q-takeoff-import) and the export that fills a blank one (takeoff-fill.ts).
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotATakeoff = exports.COLUMNS = exports.HEADER_ROWS = exports.REVIEW_GATE = exports.SUMMARY = exports.PAINT_SLOTS = exports.FINANCE_RATE = exports.YEARLY = exports.SCHEDULE_YEAR_COLUMNS = exports.SCHEDULE_LABEL_COLUMN = exports.EXTRA_SERVICE_COLUMN = exports.MAINTENANCE = exports.HEADER = exports.SHEET = void 0;
exports.locate = locate;
exports.SHEET = { takeOff: 'Take Off', summary: 'Summary', review: 'REVIEW' };
/** Header inputs (rows 1–34). Percentages are fractions in the workbook: 0.1 = 10 %. */
exports.HEADER = {
    branchLabour: 'I3',
    labourSell: 'M3',
    labourCost: 'N3',
    overtimeShare: 'K4',
    overtimeSell: 'M4',
    overtimeCost: 'N4',
    foremanShare: 'K5',
    foremanSell: 'M5',
    foremanCost: 'N5',
    abseilBranch: 'H6',
    abseilShare: 'K6',
    abseilSell: 'M6',
    abseilCost: 'N6',
    washRate: 'K7',
    allowanceSell: 'M8',
    allowanceCost: 'N8',
    markupMaterials: 'J16',
    markupOther: 'J17',
    defaultCoats: 'N16',
    defaultSpread: 'N17',
    consumables: 'N18',
    negotiatingFactor: 'N29',
    maintenanceAgreement: 'Z4',
};
/**
 * The Maintenance Agreement Set Up (Take Off R2:Z11) and its Overall Summary (Z27, Z28), read when Z4 is "Yes" (#515).
 * T3 names the servicing branch and labour type as I3 does ("MELBOURNE subbie"); Y3/Z3 are its sell and cost.
 */
exports.MAINTENANCE = {
    servicingLabour: 'T3',
    servicingSell: 'Y3',
    servicingCost: 'Z3',
    extraSell: 'Y5',
    extraCost: 'Z5',
    years: 'Z7',
    secondRepaintCoats: 'Z8',
    extraServicing: 'Z9',
    includeAccess: 'Z10',
    includePrelims: 'Z11',
    contractCost: 'Z27',
    contractSell: 'Z28',
};
/** Each serviced row's Extra Service (R48 = $Z$9 unless typed over). */
exports.EXTRA_SERVICE_COLUMN = 'R';
/** A block's Schedule of Work row: "Schedule of Work:" in S, then one year per column T (year 1) … AH (year 15). */
exports.SCHEDULE_LABEL_COLUMN = 'S';
exports.SCHEDULE_YEAR_COLUMNS = ['T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH'];
/** The Yearly Summaries sheet: its Maintenance Type (O6) and the Totals row's sell and cost per year (F16, G16 … AB16, AC16). */
exports.YEARLY = {
    sheet: 'New_Yearly Summaries (ES-UP)',
    paymentType: 'O6',
    startYear: 'F8',
    /** The finance interest, year by year in each year's sell column. */
    interestRow: 15,
    totalsRow: 16,
    yearColumns: [['F', 'G'], ['H', 'I'], ['J', 'K'], ['L', 'M'], ['N', 'O'], ['P', 'Q'], ['R', 'S'], ['T', 'U'], ['V', 'W'], ['X', 'Y'], ['Z', 'AA'], ['AB', 'AC']],
};
/** The finance rate on the Cost PA sheet (Y10, a fraction: 0.08). */
exports.FINANCE_RATE = { sheet: 'Cost PA', cell: 'Y10' };
/** The six paint slots: label, cost $/L and sell $/L (cost × (1 + materials mark-up)). Surfaces point at a slot by its sell price. */
exports.PAINT_SLOTS = [
    { key: 'standard', label: 'G11', cost: 'J11', sell: 'I11' },
    { key: 'twopacklight', label: 'G12', cost: 'J12', sell: 'I12' },
    { key: 'twopackdark', label: 'G13', cost: 'J13', sell: 'I13' },
    { key: 'other1', label: 'K11', cost: 'N11', sell: 'M11' },
    { key: 'other2', label: 'K12', cost: 'N12', sell: 'M12' },
    { key: 'other3', label: 'K13', cost: 'N13', sell: 'M13' },
];
exports.SUMMARY = {
    totalSell: 'K53',
    labour: { sell: 'K66', cost: 'M66' },
    paint: { sell: 'K76', cost: 'M76' },
    hire: { sell: 'K89', cost: 'M89' },
    prelims: { sell: 'K107', cost: 'M107' },
    contractAdjustment: 'K109',
    overall: { sell: 'K111', gp: 'L111', cost: 'M111' },
};
/** REVIEW!M86 "Is this a viable project?": the Summary's total sell shows only when "Yes". */
exports.REVIEW_GATE = 'M86';
/** The header rows: fixed in every rev seen. */
exports.HEADER_ROWS = 34;
/** Columns the importer reads on the Take Off sheet. */
exports.COLUMNS = 'ABCDEFGHIJKLMN';
class NotATakeoff extends Error {
}
exports.NotATakeoff = NotATakeoff;
const squash = (text) => text.replace(/\s+/g, '').toLowerCase();
const range = (from, to) => Array.from({ length: Math.max(0, to - from) }, (_, i) => from + i);
/** Find every area block and the rows inside it by their labels. */
function locate(cells, lastRow) {
    const T = exports.SHEET.takeOff;
    const a = (r) => squash(cells.text(T, `A${r}`));
    const c = (r) => squash(cells.text(T, `C${r}`));
    const rows = range(1, lastRow + 1);
    const headers = rows.filter((r) => a(r) === 'building/area');
    const exterior = rows.find((r) => a(r) === 'exterior') ?? Number.POSITIVE_INFINITY;
    const grandTotal = rows.find((r) => a(r) === 'overalltotal');
    if (!headers.length || grandTotal === undefined)
        throw new NotATakeoff('Not an STM002 Repaint Take Off: no "Building/Area" blocks or no "Overall Total" row.');
    const blocks = headers.map((header, i) => {
        const end = headers[i + 1] ?? grandTotal;
        const totalLabel = range(header + 2, end).find((r) => c(r).startsWith('totalm'));
        // Down time is the one extra row nobody renames (Sundry and even Wash get typed over); the extras sit just above it.
        const downtime = range(header + 2, end).find((r) => a(r).startsWith('downtime'));
        if (totalLabel === undefined || downtime === undefined) {
            throw new NotATakeoff(`Area block ${i + 1} (row ${header}) has no ${downtime === undefined ? '"Down time" row' : '"Total m²" row'}: not a layout this importer knows.`);
        }
        // The extras: labelled rows above Down time, up to the blank row under the surfaces.
        let blank = downtime - 1;
        while (blank > header + 1 && a(blank) !== '')
            blank--;
        const extras = range(blank + 1, downtime);
        const wash = extras.find((r) => a(r).startsWith('wash')) ?? null;
        const scaffold = extras.find((r) => a(r).includes('scaff')) ?? null;
        const below = (test) => range(downtime, totalLabel).find(test) ?? null;
        const overtime = below((r) => a(r).startsWith('overtime'));
        const fuelLevy = below((r) => a(r) === 'fuellevy');
        const dayRows = range(downtime, totalLabel).filter((r) => c(r) === 'dayhire');
        const negotiating = below((r) => a(r).startsWith('negotiating'));
        return {
            number: i + 1,
            side: header > exterior ? 'External' : 'Internal',
            header,
            surfaces: range(header + 2, blank).filter((r) => a(r) !== ''),
            // Every other extra is a sundry: the "Sundry" row, renamed ("Prepare", "Roof Kit Setup"), or added.
            sundries: extras.filter((r) => r !== wash && r !== scaffold),
            wash,
            scaffold,
            downtime,
            consumables: below((r) => a(r).startsWith('consumables')),
            hire: dayRows.map((day, k) => {
                const after = range(day + 1, dayRows[k + 1] ?? fuelLevy ?? overtime ?? totalLabel);
                return { day, cartage: after.filter((r) => c(r) === 'cartage'), fuel: after.find((r) => c(r) === 'fuel') ?? null };
            }),
            fuelLevy,
            // Other trades: the "Rate" rows after the hire, whatever they're called (older revs have no Fuel Levy row).
            otherTrades: range(downtime, overtime ?? totalLabel).filter((r) => c(r) === 'rate' && r !== fuelLevy),
            overtime,
            foreman: below((r) => a(r).startsWith('foreman')),
            abseil: below((r) => a(r).startsWith('abseil')),
            negotiating,
            notes: range((negotiating ?? downtime) + 1, totalLabel - 1).filter((r) => /exclud|note/.test(a(r))),
            totals: totalLabel - 1,
            schedule: range(totalLabel, end).find((r) => squash(cells.text(T, `${exports.SCHEDULE_LABEL_COLUMN}${r}`)) === 'scheduleofwork:') ?? null,
        };
    });
    return { blocks, grandTotal };
}
